export default "__VITE_ASSET__DG2c0k0X__"